import { application } from "../../app"

import "./form/";

import ContainerTogglerController from "./container_toggler_controller"
application.register("container-toggler", ContainerTogglerController)

import InputDisablerController from "./input_disabler_controller"
application.register("input-disabler", InputDisablerController)

import TruncatedTextTogglerController from "./truncated_text_toggler_controller"
application.register("truncated-text-toggler", TruncatedTextTogglerController)

import ValueSwitcherController from "./value_switcher_controller"
application.register("value-switcher", ValueSwitcherController)

import TwoFactorAuthentication from "./two_factor_authentication_controller"
application.register("two-factor-authentication", TwoFactorAuthentication)

import JsonHighlighterController from "./json_highlighter_controller"
application.register("json-highlighter", JsonHighlighterController)

import PrettyPriceController from "./pretty_price_controller"
application.register("pretty-price", PrettyPriceController)
